import { Text, Table, Anchor } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { IAgentReview } from '../../../api/AgentSignup/AgentSignup.types';
import { IResponse } from '../../../api/Base/Base.types';


interface Props {
    agentData?: IResponse<IAgentReview>
}

function AgentSearchTable({agentData}: Props) {
    const navigate = useNavigate();
    
    if (!agentData) return (<div></div>)
    
    const rows = agentData.data.map((curData) => {
        return (
            <tr key={curData.agentID}>
                <td>
                    <Anchor
                        component="button"
                        type="button"
                        color="gray"
                        onClick={() => navigate(`/agent/review/${curData.agentID}`)}
                        size="sm"
                    >
                        {curData.agentName}
                    </Anchor>
                </td>
                <td>{curData.email}</td>
                <td>{curData.countryCode}</td>
                <td>{curData.agentStatus}</td>
            </tr>
        )
    });

    return ( 
        <Table striped>
            <thead>
            <tr>
                <th>Agent Name</th>
                <th>Email</th>
                <th>Country Code</th>
                <th>Agent Status</th>
            </tr>
            </thead>
            <tbody>{rows}</tbody>
        </Table>
    )
}

export default AgentSearchTable;